import React, {PropTypes} from "react";

class PersonalInfo extends React.Component {

  constructor() {
    super();
  }

  render() {
    return (
      <div className="col-md-12">
        <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
          <thead>
          <tr>
            <th cellPadding="0" colSpan="4">
              <span className="bold pull-left">Other Info</span>
              <span className="bold hrms-link pull-right"><a onClick={this.props.edit}><i className="icon-edit"></i> Edit</a></span>

            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td style={{align: 'left', width: '18%'}}>Blood Group :</td>
            <td style={{align: 'left', width: '28%'}}>
              <span id="ContentPlaceHolder1_txtName"
                    className="GenText">{this.props.employee.bloodGroup ? this.props.employee.bloodGroup : 'NA'}</span>
            </td>
            <td style={{align: 'left', width: '18%'}}>Nationality :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_txtSpouseName"
                    className="GenText">{this.props.employee.nationality ? this.props.employee.nationality : 'NA'}</span>
            </td>
          </tr>
          <tr>
            <td style={{align: 'left'}}>Father Name :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.fatherName ? this.props.employee.fatherName : 'NA'}</span>
            </td>

            <td style={{align: 'left'}}>Mother Name :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary"
                    className="GenText">{this.props.employee.motherName ? this.props.employee.motherName : 'NA'}</span>
            </td>
          </tr>


          <tr>
            <td style={{align: 'left'}}>Father Age :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.fatherAge ? this.props.employee.fatherAge : 'NA'}</span>
            </td>
            <td style={{align: 'left'}}>Mother Age :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary"
                    className="GenText">{this.props.employee.motherAge ? this.props.employee.motherAge : 'NA'}</span>
            </td>
          </tr>
          <tr>
            <td style={{align: 'left'}}>Spouse Name:</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.spouseName ? this.props.employee.spouseName : 'NA'}</span>
            </td>

            <td style={{align: 'left'}}>Spouse DOB:</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.spouseDOB ? this.props.employee.spouseDOB : 'NA'}</span>
            </td>
          </tr>

          <tr>

            <td style={{align: 'left'}}>Child Name 1 :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.childName1 ? this.props.employee.childName1 : 'NA'}</span>
            </td>
            <td style={{align: 'left'}}>Child Name 2 :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary"
                    className="GenText">{this.props.employee.childName2 ? this.props.employee.childName2 : 'NA'}</span>
            </td>

          </tr>
          <tr>
            <td style={{align: 'left'}}>Child 1 DOB:</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary"
                    className="GenText">{this.props.employee.child1DOB ? this.props.employee.child1DOB : 'NA'}</span>
            </td>
            <td style={{align: 'left'}}>Child 2 DOB:</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.child2DOB ? this.props.employee.child2DOB : 'NA'}</span>
            </td>
          </tr>
          </tbody>
        </table>


      </div>
    );
  }
}

PersonalInfo.propTypes = {};

export default PersonalInfo;





/** WEBPACK FOOTER **
 ** ./src/components/joiningForm/Tables/OtherInfo.js
 **/